import { setup } from "axios-cache-adapter";
// constants
import { BASE_URL } from "src/utils/constants";

const api = setup({
  baseURL: BASE_URL(),

  cache: {
    exclude: {
      // Only exclude PUT, PATCH and DELETE methods from cache
      methods: ["put", "patch", "delete"],
    },
    debug: true,
    maxAge: 5 * 60 * 1000,
  },
});

export const getTableData = async () => {
  const response = await api.post("/TabularData");

  return response;
};

export const getChartData = async () => {
  const response = await api.post("/PieChartData");

  return response;
};
